import { AjaxUtil } from "./ajax-util";

export interface ICspUtil {
    start: () => void;
    end: () =>  void;
    eventHandler: (e: SecurityPolicyViolationEvent) => Promise<void>;
}

interface INavigation {
    getFeaturePathFromHashPath: (hashPath: string) => string;
    hashPath: string;
}

export class CspUtil implements ICspUtil {
    private endpoint: string;
    private navigation: string | INavigation;
    constructor(endpoint: string, navigation: string | INavigation) {
        this.endpoint = endpoint;
        this.navigation = navigation;
    }
    eventHandler: ICspUtil['eventHandler'] = async (e) => {
        // POST to the API endpoint.
        const cspReport = {
            'csp-report': {
                'blocked-uri': e['blockedURI'],
                'column-number': e['columnNumber'],
                'dfFeaturePath': this.navigation && typeof(this.navigation) !== 'string' ? this.navigation.getFeaturePathFromHashPath(this.navigation.hashPath) : this.navigation,
                'disposition': e['disposition'],
                'document-uri': e['documentURI'],
                'effective-directive': e['effectiveDirective'],
                'line-number': e['lineNumber'],
                'original-policy': e['originalPolicy'],
                'referrer': e['referrer'],
                'script-sample': e['sample'],
                'source-file': e['sourceFile'],
                'status-code': e['statusCode'],
                'violated-directive': e['violatedDirective']
            }
        }
        return await AjaxUtil.postInsecure(this.endpoint, cspReport);
    }

    start: ICspUtil['start'] = () => {
        document.addEventListener('securitypolicyviolation', this.eventHandler);
    }

    end: ICspUtil['end'] = () => {
        document.removeEventListener('securitypolicyviolation', this.eventHandler);
    }
}

export default CspUtil;